import { computed } from 'vue'
import { useQueryClient, useMutation, useQuery } from '@tanstack/vue-query'
import userManager from '../auth/oidc'

let isListenerInitialized = false

export function useUser() {
  const queryKey = ['user']
  const queryClient = useQueryClient()

  // Écouter les renouvellements automatiques du token pour mettre à jour le cache
  if (!isListenerInitialized) {
    userManager.events.addUserLoaded((user) => {
      queryClient.setQueryData(queryKey, user)
    })
    isListenerInitialized = true
  }

  // Récupération du user actuel
  const { isSuccess, isPending, isError, data, error, refetch } = useQuery({
    queryKey,
    queryFn: () => userManager.getUser(),
  })

  async function getUser() {
    return await queryClient.ensureQueryData({
      queryKey,
      queryFn: () => userManager.getUser(),
    })
  }
  // Mutation pour rafraîchir le token
  const { mutateAsync: refreshToken, isPending: isRefreshing } = useMutation({
    mutationFn: () => userManager.signinSilent(),
    onSuccess: (userData) => {
      // Met à jour le cache avec le nouveau user après rafraîchissement
      return queryClient.setQueryData(queryKey, userData)
    },
  })


  // Mutation pour la déconnexion
  const { mutateAsync: signoutRedirect } = useMutation({
    mutationFn: () => userManager.signoutRedirect(),
    onSuccess: () => {
      // Nettoie le cache après déconnexion
      queryClient.setQueryData(queryKey, null)
    },
  })

  // Computed pour vérifier si le token est expiré
  const isExpired = computed(() => {
    return data.value?.expired ?? false
  })

  /** Teste une permission de l'utilisateur! */
  const has_permission = computed(() => {
    return (permission: string) => {
      if (!data){
        return undefined
      }
      const permissions_set = new Set(data.value?.profile.permissions as string[])
      return permissions_set.has(permission)
    }
  })

  /** raccourci vers data.profile.isstaff */
  const is_staff = computed(()=> data?.value?.profile.is_staff)

  /** raccourci vers l'id user (data.profile.sub) */
  const user_id = computed(() => data?.value?.profile.sub)

  return {
    data,
    getUser,
    isPending,
    isError,
    isSuccess,
    error,
    isRefreshing,
    isExpired,
    refreshToken,
    signoutRedirect,
    refetch,
    userManager,
    has_permission,
    is_staff,
    user_id
  }
}
